<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="标签类型">
              <a-select
                placeholder="请选择标签类型"
                v-model="queryParam.tagType"
              >
                <a-select-option value="1">个人</a-select-option>
                <a-select-option value="2">企业</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12">
            <a-form-item label="分组">
              <a-input
                placeholder="输入分组名称查询"
                v-model="queryParam.groupName"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12">
            <a-form-item label="标签">
              <a-input
                placeholder="输入标签名称查询"
                v-model="queryParam.name"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="handleAdd" type="primary" icon="plus"
        >新建分组</a-button
      >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="1">
            <a-icon type="delete" @click="batchDel" />
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a
          style="font-weight: 600"
          >{{ selectedRowKeys.length }}</a
        >项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        bordered
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        :rowKey="r => r.id"
        @change="handleTableChange"
      >
        <template slot="tags" slot-scope="text, record">
          <a-tag color="blue" v-for="item in record.tag" :key="item.id">
            {{ item.name }}
          </a-tag>
        </template>
        <template slot="avatarslot" slot-scope="text, record">
          <div class="anty-img-wrap">
            <a-avatar
              shape="square"
              :src="getAvatarView(record.avatar)"
              icon="user"
            />
          </div>
        </template>
        <!-- <span slot="expandedRowRender" slot-scope="record">
          <a-tag v-for="item in record.tag" :key="item.id">{{item.name}}</a-tag>
        </span> -->
        <span slot="action" slot-scope="text, record">
          <!-- <a @click="handleEdit(record)" v-has="'user:edit'">编辑</a>-->
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />

          <a-dropdown>
            <a class="ant-dropdown-link"> 更多 <a-icon type="down" /> </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDelete(record.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <tag-modal ref="modalForm" @ok="modalFormOk"></tag-modal>
  </a-card>
</template>

<script>
import { deleteTag } from '@/api/api';
import { getFileAccessHttpUrl } from '@/api/manage';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import TagModal from './TagModal';
import moment from 'moment';

export default {
  name: 'tagList',
  mixins: [JeecgListMixin],
  components: {
    TagModal
  },
  // inject: ['reload'],
  data() {
    return {
      description: '标签管理列表',
      queryParam: {},
      recycleBinVisible: false,
      columns: [
        // {
        //   title: 'GroupId',
        //   align: "center",
        //   dataIndex: 'groupId',
        //   width: 120,
        //   sorter: true
        // },
        {
          title: '标签类型',
          align: 'center',
          width: 100,
          dataIndex: 'tagType',
          customRender: function(text, record, index) {
            if (text == 1) {
              return '个人';
            } else if (text == 2) {
              return '企业';
            }
          }
        },
        {
          title: '标签分组',
          align: 'left',
          width: 140,
          dataIndex: 'name'
        },
        {
          title: '标签',
          align: 'left',
          dataIndex: 'tags',
          ellipsis: true,
          scopedSlots: { customRender: 'tags' }
        },
        {
          title: '创建时间',
          align: 'center',
          width: 180,
          dataIndex: 'createTime',
          customRender: function(text, record, index) {
            if (text != null) {
              return moment(Number(text) * 1000).format('YYYY-MM-DD HH:mm:ss');
            } else {
              return text;
            }
          }
        },
        {
          title: '排序',
          align: 'center',
          width: 100,
          dataIndex: 'order'
        },
        // {
        //   title: '关联客户数',
        //   align: "center",
        //   width: 100,
        //   dataIndex: 'userNum',
        //   customRender: function (text, record, index) {

        //     if (text == null || text == undefined) {
        //       return '-'
        //     } else {
        //       return text
        //     }
        //   }
        // },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 140
        }
      ],
      url: {
        list: process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/tag/data',
        deleteBatch:
          process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/tag/batchDeleteTags'
      }
    };
  },
  computed: {
    importExcelUrl: function() {
      return `${process.env.GATEWAY + process.env.VUE_APP_CMS_SYSTEM}/${
        this.url.importExcelUrl
      }`;
    }
  },
  methods: {
    getAvatarView: function(avatar) {
      return getFileAccessHttpUrl(avatar);
    },
    handleDelete(tagIds) {
      console.log('删除标签');
      const that = this;
      tagIds = { tagIds: tagIds };
      let obj = deleteTag(tagIds);
      obj
        .then(res => {
          if (res.success) {
            that.$message.success(res.message);
            that.$emit('ok');
          } else {
            that.$message.warn(res.message);
            that.$emit('error');
          }
        })
        .finally(() => {
          // that.loadData();
          that.searchReset();
          // that.reload()
        });
    },
    handleMenuClick(e) {
      console.log('点击批量删除按钮');
      if (e.key === '1') {
        console.log('批量删除');
        this.batchDel();
      }
    },
    handleChangePassword(username) {
      this.$refs.passwordmodal.show(username);
    },
    handleAgentSettings(username) {
      this.$refs.sysUserAgentModal.agentSettings(username);
      this.$refs.sysUserAgentModal.title = '用户代理人设置';
    },
    passwordModalOk() {
      //TODO 密码修改完成 不需要刷新页面，可以把datasource中的数据更新一下
    },
    // 时间戳转换格式
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-';
      var D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      var h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':';
      var s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
